const data = [
  {
    "title": "Start",
    "content": `
      <p>Hello!</p>

      <p>Welcome to Hi-Health's Personal Health & Nutrition Assessment.</p>
      
      <p>Vitamins and supplements can be complicated. Our 2-3 minute online assessment is designed to identify your specific health concerns and provide a list of recommended products that will meet your needs.</p>
    `,
    "optional": false,
    "mapping": "name",
    "input": "none",
    "answer": null,
    "startOver": false,
    "button": "Begin the assessment"
},
// {
//   "title": "Hello, ${name}! It's nice to meet you!",
//   "bind": "name"
// },
{
  "title": "How many cups of fruits and vegetables do you typically eat per day?",
  "optional": false,
  "mapping": null,
  "input": "select",
  "answer": {
      "Less than 5 cups per day": {
        "items": [31486537433137]
      },
      "More than 5 cups per day": null
  },
  "group": "Whole Body Supplement"
},
{
  "title": "Do you avoid eating dairy, eggs, or meat?",
  "optional": false,
  "mapping": null,
  "input": "select",
  "answer": {
      "Yes": {
          "items": [31491859447857]
      },
      "No": null
  },
  "group": "For Vegans & All Day Energy"
},
{
  "title": "How many servings of calcium rich foods do you eat per day?",
  "optional": false,
  "mapping": null,
  "input": "select",
  "answer": {
      "Less than 2 servings per day": null,
      "More than 2 servings per day": {
          "items": [31599597355057]
      }
  },
  "group": "Bone & Joint Health"
},
{
  "title": "How many servings of fish do you eat per week?",
  "optional": false,
  "mapping": null,
  "input": "select",
  "answer": {
    "Less than 3-4 servings per week": {
      "items": [31491960045617]
    },
    "More than 3-4 servings per week": null
  },
  "group": "Whole Body Supplement"

},
{
  "title": "How many hours per day do you spend looking at a computer, smart phone, tablet or TV screen?",
  "optional": false,
  "mapping": null,
  "input": "select",
  "answer": {
      "Less than 4 hours": null,
      "More than 4 hours": { "items": [31666832605233] }
  },
  "group": "Eye Support"
},
{
  "title": "What are your top health concerns?",
    "help": "Select all that apply",
    "optional": false,
    "mapping": null,
    "input": "multiselect",
    "answer": {
        "Bone & Joint Health": { "show": [7], "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/bone.svg' },
        "Energy Level": { "show": [8], "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/energy.svg' },
        "Stress & Anxiety": { "show": [9], "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/stress.svg' },
        "Weight Loss": { "show": [10], "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/weight.svg' },
        "Sleep": { "show": [11], "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/sleep.svg' },
        "Digestive Health": { "show": [12], "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/digestive.svg' },
        "Heart Health": { "show": [13], "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/heart.svg' },
        "Men's Health": { "show": [14], "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/mens-health.svg' },
        "Women's Health": { "show": [15], "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/womens-health.svg' },
        "Immune Support": { "show": [16], "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/immune.svg' },
        "Focus & Memory": { "show": [17], "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/focus.svg' }
    }
},
{
  "title": "Do you have any of the following conditions?",
  "optional": true,
  "mapping": null,
  "input": "multiselect",
  "answer": {
      "Arthritis": { "items": [31504366796849] },
      "Osteoporosis": { "items": [31485257973809] },
      "Tendinitis": { "items": [31504366796849] },
      "None of the above": null
  },
  "group": "Bone & Joint Health"
},
{
  "title": "What best describes your typical daily energy level?",
  "optional": true,
  "mapping": null,
  "input": "multiselect",
  "answer": {
      "Low all day": { "items": [31549286842417] },
      "Low energy during the \"afternoon slump\"": { "items": [31491859447857] },
      "Great Energy all day long": null,
      "Low energy at night": { "items": [31491859447857] }
  },
  "group": "Energy Support"
},
{
  "title": "What is your typical daily stress or anxiety level?",
  "optional": true,
  "mapping": null,
  "input": "multiselect",
  "answer": {
      "Stressed all the time": { "items": [31509470445617] },
      "Stressed sometimes": { "items": [31491732111409] },
      "Anxious all the time": { "items": [31509470445617] },
      "Anxious sometimes": { "items": [31491732111409] },
      "Rarely anxious or stressed": null
  },
  "group": "Stress & Anxiety"
},
{
  "title": "What best describes your body weight?",
  "optional": true,
  "mapping": null,
  "input": "multiselect",
  "answer": {
      "Not overweight": { "items": [31490704244785] },
      "Less than 10 lbs. overweight": { "items": [31490704244785] },
      "More than 10 lbs. overweight": { "items": [31490681241649, 31485758505009] }
  },
  "group": "Weight Management"
},
{
  "title": "How well do you typically sleep?",
  "optional": true,
  "mapping": null,
  "input": "multiselect",
  "answer": {
      "I experience frequent sleep interruptions most nights.": { "items": [31504342319153, 31485758505009]},
      "I struggle to fall asleep most nights.": { "items": [31504342319153] },
      "I sleep well most nights.": null
  },
  "group": "Restful Sleep"
},
{
  "title": "Do you typically experience any of the following digestive conditions?",
  "optional": true,
  "mapping": null,
  "input": "multiselect",
  "answer": {
      "Constipation": { "items": [31485447471153] },
      "Bloating or Gas": { "items": [31489461092401] },
      "Acid Reflux or Heartburn": { "items": [31490826141745] },
      "Irritable Bowel Syndrome (IBS)": { "items": [31490854354993] },
      "No digestive health conditions": null
  },
  "group": "Digestive Health"
},
{
  "title": "Do you have any of the following heart conditions?",
  "optional": true,
  "mapping": null,
  "input": "multiselect",
  "answer": {
      "High Cholesterol": { "items": [31504358604849] },
      "High Blood Pressure": { "items": [31485282418737] },
      "Cardiovascular Disease": { "items": [31548968042545] },
      "No heart health conditions": null
  },
  "group": "Heart Health"
},
{
  "title": "Do you have any of the following men's health issues?",
  "optional": true,
  "mapping": null,
  "input": "multiselect",
  "answer": {
      "Lack of sexual drive": { "items": [31526446891057, 31490386624561] },
      "Frequent urination": { "items": [31504311812145] },
      "No men's health issues": null
  },
  "group": "Men's Health"
},
{
  "title": "Do you have any of the following women's health issues?",
  "optional": true,
  "mapping": null,
  "input": "multiselect",
  "answer": {
      "Hair, skin & nail health": { "items": [31504362962993] },
      "Frequent vaginal yeast infection": { "items": [31489549467697] },
      "Low bone density": { "items": [31485257973809] },
      "Night sweats or vaginal dryness due to menopause": { "items": [31504347004977] },
      "No women's health issues": null
  },
  "group": "Women's Health"
},
{
  "title": "Do you have any of the following immunity health conditions?",
  "optional": true,
  "mapping": null,
  "input": "multiselect",
  "answer": {
      "Seasonal allergies": { "items": [31540692516913] },
      "Frequent colds during season changes": { "items": [31549416603697] },
      "No immune health conditions": null
  },
  "group": "Immune Support"
},
{
  "title": "What best describes your typical ability to focus or remember?",
  "optional": true,
  "mapping": null,
  "input": "multiselect",
  "answer": {
      "I am frequently not able to focus.": { "items": [31491859447857] },
      "I am frequently forgetful.": { "items": [31489848508465] },
      "I am currently experiencing age-related cognitive decline.": { "items": [31504046063665] },
      "I am typically able to focus and remember.": null
  },
  "group": "Focus & Memory"
},
{
  "title": "Wrapping up",
  "content": `
    <p>Almost done!</p>
    
      <div class="doctor-profiles">
        <article class="doctor-profile">
        <img class='doctor-profiles__image' src='//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/markham.jpg'>
        <p>Dr. Scott Markham <span>Medical Advisory Board Member</span></p>
      </article>
      </div>

      <p>Just a few more details while we compile your information and prepare your recommendations.</p>
  `,
  "optional": false,
  "mapping": null,
  "input": "multi",
  "answer": null,
  "questions": {
    'text': {
      'name': "Name*", 
      'email': "Email*"
    },
    'multiselect': {
      'title': "I would like to receive emails and promotions about the following health concerns.",
      'answer': {
        "Immune Support": { "list": true, "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/immune.svg' },
        "Focus & Memory": { "list": true, "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/focus.svg' },
        "Weight Loss": { "list": true, "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/weight.svg' },
        "Sleep": { "list": true, "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/sleep.svg' },
        "Bones and Joints": { "list": true, "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/bone.svg' },
        "Anxiety and Stress": { "list": true, "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/stress.svg' },
        "Digestive Health": { "list": true, "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/digestive.svg' },
        "Heart Health": { "list": true, "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/heart.svg' },
        "Energy": { "list": true, "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/energy.svg' },
        "Men's Health": { "list": true, "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/mens-health.svg' },
        "Women's Health": { "list": true, "icon": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/womens-health.svg' },
      }
    }
  },
  "after_content": `
    <p>Thank you for participating in our online health and nutrition assessment.</p>
    <p>We have prepared a customized shopping cart of products that will meet your needs based on your specific health concerns.</p>
    <p>Please feel free to make adjustments to your shopping cart by adding or removing items.</p>
  `,
  "button": "Complete"
}
]



const icons = {
  "Bone & Joints": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/bone.svg',
  "Bone & Joint Health": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/bone.svg',
  "For Energy": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/energy.svg',
  "Energy Support": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/energy.svg',
  "Stress & Anxiety": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/stress.svg',
  "Weight Loss": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/weight.svg',
  "Weight Management": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/weight.svg',
  "Sleep": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/sleep.svg',
  "Restful Sleep": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/sleep.svg',
  "Digestive Health": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/digestive.svg',
  "Heart Health": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/heart.svg',
  "Men's Health": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/mens-health.svg',
  "Women's Health": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/womens-health.svg',
  "Immune Support": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/immune.svg',
  "Focus & Memory": '//cdn.shopify.com/s/files/1/0045/7156/2033/t/27/assets/focus.svg' 
}


Vue.component( 'SelectComponent', {
  props: ['options'],
  template: '<option>Yo</option>'
})


Vue.component('navigator', {
  props: ['questions', 'current', 'completed', 'optional'],
  template: `
    <nav class="">
      <ul>
      
      
        <li 
          v-for="(question, index) in questions" 
          v-if="show(question,index)"

          v-bind:class="{ active: isActive(index), completed: isCompleted(index)}"
          :href="question.title | formatSlug | hash"
        >
          <a v-on:click="$emit('goto', index, $event, isCompleted(index));" :href="question.title | formatSlug | hash">{{ question.title }}</a>
        </li>

      </ul>

    </nav>
  
  `,
  filters: {
    hash: function(value) {
      return '#' + value;
    }
  },
  methods: {
    isActive: function(index) {
      return this.current === index;
    },
    isCompleted: function(index) {
      return this.completed.indexOf(index) > -1;
    },
    debug(event) {
      console.log(event);
    },
    show(question,index) {
      if ( !question.optional && question.hasOwnProperty('answer') || question.hasOwnProperty('answer') && this.optional.indexOf(index) > -1 ) return true
    }

  }
})


Vue.component('question-group', {
  props: ['question', 'index', 'current', 'show', 'name'],
  template: `
    <div class="form-group col flex-column"
      style="padding: 2rem 3rem;"
      v-show="show"
      v-bind:key="index"
    >
        <template v-if="question.input === 'multi'">

          <div v-html="question.content"></div>

          <div v-for="(question, index) in question.questions.text" class="form-group" style="align-items: center !important; order: initial;">
            <label style="min-width: 4rem; text-align: left;font-size: 1rem;" class="mb-1" :for="index">{{question}}: </label>
            <input required @input="$emit('add-data', index, $event)" type="text" class="form-control" :id="index" placeholder="">
          </div>

            <template v-if="question.questions.multiselect">
            <br/><p class="">{{question.questions.multiselect.title}}</p>
            <p class="mb-1" style="font-size: 1em;margin-top: -10px;">Select all that apply</p>
            <div class="check-wrapper check-wrapper--inline">
            <div v-for="(answer, index) in question.questions.multiselect.answer" class="form-check">

              <template v-if="hasProp(answer,'list')">
                <input v-on:click="$emit('add-list', index, $event.target.checked)" class="form-check-input" type="checkbox" :value="index" :id="index | formatSlug('mailing-list')">
                
                <label class="form-check-label form-check-label--with-image" :for="index | formatSlug('mailing-list')">
                

                <img class="form-check-label__image" v-bind:src="answer.icon" />
                  {{ index }}
                </label>
              </template>

            </div>
            </div>
          </template>

          <div v-html="question.after_content"></div>

          <div class="button-wrapper mt-1">
            <button style="display:block; width: auto;" class="btn btn-outline" v-on:click="$emit('advance-form', true, $event); $emit('add-history', index)">{{ question.button }}</button>
          </div>
        </template>
      
        
        <template v-if="question.input === 'text'">
          <label class="mb-1" for="">{{question.title}}</label>
          <input v-model="sync_name" class="form-control" id="" placeholder="">

          <div class="button-wrapper mt-1">
            <template v-if="index > 0"><button class="btn btn-outline" v-on:click="$emit('back-form')">Previous</button></template>
            <button class="btn btn-outline" v-on:click="$emit('advance-form'); $emit('add-history', index)">Next</button>
          </div>
        </template>
        <template v-else-if="question.input === 'select'">
          <label class="mb-1" for="">{{question.title}}</label>
          
          
          <template v-if="getLength(question.answer) > 2">
          <select class="form-control" id="">
            <option v-for="(answer, index) in question.answer">{{index}}</option>
          </select>
          </template>

          

          <template v-else-if="getLength(question.answer) == 2">
          <button v-for="(answer, index) in question.answer" class="btn btn-outline btn-questionaire" v-on:click="$emit('advance-form'); $emit('add-history', index); $emit('answer', answer, true, question);">{{ index }}</button>
          
            
          </template>

        </template>
        <template v-else-if="question.input === 'multiselect'">
          <div class="optional-group-image" v-if="question.optional">
            <img class="form-check-label__image" v-bind:src="icons[question.group]" />
            <p>{{ question.group }}</p>
          </div>

          <p class="">{{question.title}}</p>
          <p class="mb-1" style="font-size: 1em;margin-top: -10px;">Select all that apply</p>
          <div class="check-wrapper">
          <div v-for="(answer, index) in question.answer" class="form-check">

            <template v-if="hasProp(answer,'show')">
              <input v-on:click="$emit('add-optional', answer.show, $event.target.checked)" class="form-check-input" type="checkbox" :value="answer" :id="index | formatSlug">
              
              <label class="form-check-label form-check-label--with-image" :for="index | formatSlug">
                

                <img class="form-check-label__image" v-bind:src="answer.icon" />
                {{ index }}
              </label>
            </template>

            <template v-else>
              <input v-on:change="$emit('answer', answer, $event.target.checked, question)" class="form-check-input" type="checkbox" :value="answer" :id="index | formatSlug">
              
              <label class="form-check-label" :for="index | formatSlug">
                {{ index }}
              </label>
            </template>

          </div>
          </div>

          <div class="button-wrapper mt-1">
            <template v-if="index > 0"><button class="btn btn-outline" v-on:click="$emit('back-form')">Previous</button></template>
            <button class="btn btn-outline" v-on:click="$emit('advance-form'); $emit('add-history', index)">Next</button>
          </div>
        </template>
        <template v-else-if="question.input === 'none'">
          <div v-html="question.content"></div>

          <div class="button-wrapper mt-1">
            <button style="display:block; width: auto;" class="btn btn-outline" v-on:click="$emit('advance-form', false, $event); $emit('add-history', index)">{{question.button}}</button>
          </div>
        </template>
      
        <template v-if="question.bind">
          <p>{{ question.title | formatBind(name) }}</p>

          <div class="button-wrapper mt-1">
            <template v-if="index > 0"><button class="btn btn-outline" v-on:click="$emit('back-form')">Previous</button></template>
            <button class="btn btn-outline" v-on:click="$emit('advance-form'); $emit('add-history', index)">Next</button>
          </div>
        </template>

        
        <div class="button-wrapper mt-1" v-show="question.startOver !== false">
          <span class="cancel-button" v-on:click="$emit('back-form', 0, true)">Start Over</span>
        </div>

      
    </div>
  `,
  computed: {
    sync_name: {
      get() {
        return this.name
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    sync_inputs: {
      get() {
        // console.log('get')
      },
      set(val,test) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    debug(event) {
      console.log(event);
    },
    getLength: ( object ) => {
      return Object.keys(object).length
    },
    hasProp: ( object, prop ) => {
      if ( object === null ) {
        return false;
      }
      const property = String(prop);
      return object.hasOwnProperty(property);
    }

  },
  filters: {
    formatBind: function(value, name) {
      /**
       * Should replace with the actual bind property, 
       * we'll just need to figure out what 'bind' this really is before passing in the value...
       */
      return value.replace('{{name}', name);
    }
  }
})



var productCard = Vue.component('product-card', {

  props: ['product', 'productList', 'products'],
  template: `
  <article 
    style="margin-bottom: 2rem"
    class="col-sm-6 col-md-6 col-lg-4 col-xl-3 flex-column justify-content-center align-items-center">
      <div class="product--card">
        <header class>
        <a :href="product.onlineStoreUrl" target="_blank" style="display:block;"><img :src="product.image.transformedSrc" alt="product.image.altText" /></a>
      </header>
      
      <p class="product__title">{{ product.title }}</p>
    
    
      
    
      <button v-on:click="$emit('delete-product', $event, product.id);" style="width:auto;height: auto;" class="btn btn-outline">Remove From Recommendation</button>
      <br/><a :href="product.onlineStoreUrl" target="_blank" style="width:auto; border-bottom: 1px dotted rgba(0,0,0,0.2); text-decoration: none !important;">Learn More</a>
      </div>
    </article>
  `,
  methods: {
    debug(thing) {
      console.log('product card debug: ', thing)
    } 
  },
  computed: {
    // normalizedProduct: function() {
    //   return this.product.node
    // },
    // normalizedImage: function() {
    //   console.log(this.product);
    //   return this.product.node.images.edges[0].node
    // },
    // id: function() {
    //   // console.log(this.product);
    //   let id = atob(this.product.node.id);
    //   id = id.split('/');
    //   return parseInt(id[Math.max(...[...id.keys()])]);
    // }
  },

})


Vue.component('product-list', {
  components: { 
    child: productCard
   },
  props: ['show', 'productList', 'renderList', 'productsList'],
  template: `
  <div class="product-group col-sm-12 col-md-8 col-xl-9"
  style="display: flex;flex-wrap: wrap;"
  v-show="show"
  >
    <div class="col-sm-12">
      <h1 class="product-group__title">Recommended for You by Our Nutritional Experts</h1>
    </div>

    
    
    <div class="group col-sm-12" v-for="(products, index) in renderList">
      <div class="col-sm-12">
        <h2 class="mb-1 mt-1 list-title"><img class="list-icons" :src="icons[index]" v-show="index in icons" />{{index}}</h2>
      </div>

      <div style="display:flex;flex-wrap:wrap;">
      <child 
        v-for="(product, index) in products" 
        v-bind:product="product"
        v-bind:products="productsList"
        v-bind:productList="productList"
        v-on:delete-product="deleteProduct"
        v-bind:key="index"
      >
      </child>
      </div>
    </div>
    
  </div>
  `,
  methods: {
    deleteProduct(...args) {
      args[0].preventDefault();
      this.$emit('product-delete', args[1]);
    },
    debug(event) {
      console.log('Product list debug:', event);
    },
  }

})

Vue.component('cart', {
  props: [ 'show', 'products', 'productList'],
  template: `
  <section v-show="show" class="col-sm-12 col-md-4 col-xl-3 flex-column justify-content-center align-items-center">
    <div class="section col-md-12 cart-summary-wrapper bg-med-gray">
      <div id="cart-summary" class="cart-summary">
        <div class="cart-summary-block cart-summary__heading">
          <span>Summary</span>
        </div>

        <div class="cart-summary-block cart-summary__total d-flex justify-content-between">
          <span class="text-uppercase">Total</span>
          <span v-html="getTotal()"></span>
        </div>

        <div class="cart-summary-block cart-summary-block--no-border cart-summary__promo">
          <span style="font-size: 1.3rem;font-weight: bold;margin-top: 1rem;display: block;margin-bottom: 1rem;">Save 30% on this order today.</span><span>Promotional codes are added and delivery costs are calculated within the checkout.</span>
        </div>

        <div id="cart-update-container" class="cart-summary-block cart-summary-block--no-border">
          <button v-on:click="$emit('checkout', $event);" style="height: auto; min-height: 50px;" id="cart-update" class="cart-page-btn btn btn-brown btn-hover-light" name="update">Add to Cart & Checkout</button>
        </div>

        <div class="cart-summary-block cart-summary-block--no-border text-center">
          <a href="/" id="continueShoppingLink" class="cart-continue-shopping">Cancel &amp; Continue Shopping</a>
        </div>
      </div>
    </div>
  </section>
  `,
  methods: {
    getTotal: function() {
      let total = 0;
      if ( this.productList.length > 0 ) {
        for (let i = 0; i < this.productList.length; i++) {
          const element = this.productList[i];
          if ( 'price' in element ) {
            total += element.price;
          }
          
        }
      }
      return `${total / 100}`;
      
    }
  }
})


Vue.component('loader', {
  props: ['loading'],
  template: `
    <div v-bind:class="{ active: loading }" class="lds-ellipsis"><span class="loader__text">Loading</span><div></div><div></div><div></div><div></div></div>
  `
})


Vue.filter('formatSlug', function(value, additional) {
  let string = value.toLowerCase().replace(/[^\w\s]/gi, '').replace(/ /g, '-');
  if ( additional !== undefined ) {
    string = string + '-' + additional;
  }
  return string;
})


var _learnq = _learnq || [];

const questionaireApp = new Vue({
  el: '#questionaire-app',
  data: {
    questions: data,
    current: 0,
    history: [],
    optionalList: [],
    name: '',
    productList: [],
    completed: [],
    formStatus: false,
    loadingProducts: false,
    productsLoaded: false,
    products: {},
    mailingList: [],
    data: {},
    renderList: [],
    discountCode: '',
  },
  
  methods: {
    questionaireAlign: function() {
      if ( !this.productsLoaded ) {
        return 'stretch'
      } else {
        return 'flex-start'
      }
    },
    addData: function(id, event) {
      this.data[id] = event.target.value;
    },
    checkout: function(event) {
      event.preventDefault();


      let items = []
      for (let i = 0; i < this.productList.length; i++) {
        const element = this.productList[i];
        items.push({
          quantity: 1,
          id: element.id
        })
      }




      const data = {
        items
      }

      localStorage.setItem("storedDiscount", '42b92kot2oz6');

      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() { 
          window.location.href = '/cart'; 
        }
      });


    },
    addOptional: function(index, type) {
      if ( type ) {
        this.optionalList = this.optionalList.concat(index);
      } else {
        for (let i = 0; i < index.length; i++) {
          const removeIndex = this.optionalList.indexOf(index[i]);
          if ( removeIndex > -1 ) {
            this.optionalList.splice(removeIndex, 1);
          }
        }

      }
    },
    addList: function(index, type) {
      if ( type ) {
        this.mailingList = this.mailingList.concat(index);
      } else {

          const removeIndex = this.mailingList.indexOf(index);
          if ( removeIndex > -1 ) {
            this.mailingList.splice(removeIndex, 1);
          }

      }
    },
    backForm: function(index, clear) {
      if ( index !== undefined ) {
        this.current = index;
      } else {
        this.current = this.history.pop();
        
      }

      if ( typeof clear !== undefined && clear ) {
        this.clear();
      }

    },
    testStatus: function(current, list, total) {
      const questionObj = this.questions[current];

      if ( !questionObj.optional ) {
        return current;
      }
    
      if ( list.includes(current) === false ) {
        const next = current + 1;
        if (next <= total) {
          return this.testStatus(next, list, total);
        }
    
      } 
      
      return current;
    },
    advanceForm: function(validate, event) {
      if ( event !== undefined ) {
        event.preventDefault();
      }
      this.complete(this.current);
      let nextQuestion = this.current+1;

      if ( validate && !document.forms['questionaire-app'].reportValidity() ) {
        return false;
      }

      const nextQuestionObj = this.questions[nextQuestion];
      if ( nextQuestionObj === undefined ) {
        return this.completeForm();
      }

      const optional = nextQuestionObj.optional;

      
      if ( optional === true  ) {
        nextQuestion = this.testStatus(nextQuestion, this.optionalList, this.questions.length,)
      }



      if ( nextQuestion >= this.questions.length ) {
        return this.completeForm();
      }

      
      this.history.push(this.current);
      this.current = nextQuestion;
      window.scrollTo(0,0);
    },
    clear: function() {
      this.completed = [];
      this.optionalList = [];
      this.name = '';
      this.data = {};

      var inputs = document.getElementsByTagName("input");
      for(var i = 0; i < inputs.length; i++) {
        if(inputs[i].type == "checkbox") {
            inputs[i].checked = false; 
        }  
      }
    },
    goTo: function(index, event, isCompleted) {
      let goto = index;
      event.preventDefault();

      if ( isCompleted ) {
        this.current = goto;
      }
    },
    complete: function(index) {
      this.completed.push(index);
    },
    input: function(val) {
      this.name = val;
    },
    answer: function(answer, type, question) {
      
      if ( answer !== null ) {
        if ( answer.hasOwnProperty('items') && type ) {
          this.productAdd(answer.items, question)
        } else if ( answer.hasOwnProperty('items') && !type ) {
          this.productDelete(answer.items)
        } 
      }
    },
    productDelete: function( skus) {   
      
      if ( !Array.isArray(skus) ) {
        if ( typeof skus !== 'number' && skus.indexOf(',') > -1 ) {
          skus = skus.split(',');
        } else {
          skus = [skus];
        }
      }

      

      for (let i = 0; i < skus.length; i++) {
        const sku = parseInt(skus[i]);
        const objectIndex = this.productList.findIndex(x => x.id === sku );

        if ( objectIndex > -1 ) {
          this.productList.splice(objectIndex, 1);
        }


        for (const key in this.renderList) {
          if (this.renderList.hasOwnProperty(key)) {
            const group = this.renderList[key];

            for (let i = 0; i < group.length; i++) {
              const objectIndex = this.renderList[key].findIndex(x => x.id === sku );

              if ( objectIndex > -1 ) {
                this.renderList[key].splice(objectIndex, 1);
              }



              if (this.renderList[key].length === 0) {
                delete this.renderList[key];
              }
            
            }            
          }
        }

      }

    },
    productAdd: function(skus,question) {
      for (let i = 0; i < skus.length; i++) {
        const element = skus[i];
        const object = this.productList.findIndex(x => x.id === element);
        if ( object === -1 ) {
          this.productList.push({id: element, group: question.group})
        } else {
          if ( this.productList[object].hasOwnProperty('count') ) {
            this.productList[object].count++;
          } else {
            this.productList[object].count = 1;
          }
          
        }

      }
    },
    completeForm: function() {
      this.current = false;
      this.formStatus = true;
      this.loadingProducts = true;
      window.scrollTo(0,0);

      this.klaviyoList();

      return this.queryProducts(this.productList);
    },
    loadedProducts: function() {
      return this.loadingProducts;
    },
    isCompleted: function() {
      return this.formStatus;
    },
    klaviyoList: function() {
      // this.data.questionaireInterests = this.mailingList.toString()
      const obj = {
        '$email': this.data.email,
        'Questionaire Interests': this.mailingList.toString()
      }
      _learnq.push(['identify',  obj])
    },
    renderProducts: function(data) {
      for (let i = 0; i < data.data.nodes.length; i++) {
        const variant = data.data.nodes[i];

        if ( variant === null ) {
          continue;
        }

        const variantId = this.getProductId(variant);
        const productIndex = this.productList.findIndex(x => x.id === variantId);




        if ( productIndex > -1 ) {
          this.productList[productIndex].price = parseInt(variant.priceV2.amount * 100);
          this.productList[productIndex].title = variant.product.title;
          this.productList[productIndex].image = variant.image;
          this.productList[productIndex].onlineStoreUrl = variant.product.onlineStoreUrl;
        }
      }


      
      let renderList = {};



      for (let i = 0; i < this.productList.length; i++) {
        const element = this.productList[i];

        if ( element.group !== undefined ) {

          if ( ! ( element.group in renderList ) ) {
            renderList[element.group] = [];
          }
          renderList[element.group].push(element);
        } else {
          console.log('No group!', element);
        }
      }

      this.renderList = renderList;


      setTimeout( () => {
        this.loadingProducts = false;
      }, 700 )

      setTimeout( () => {

        this.products = data.data.nodes;
        this.productsLoaded = true;
        
      }, 1000 )
      


      return false;
    },
    getProductId: function(product) {
      let id = atob(product.id);
      id = id.split('/');
      
      return productId = parseInt(id[Math.max(...[...id.keys()])]);
    },
    queryProducts: function(products) {
      
      let queryFilter = [];

      for (let i = 0; i < products.length; i++) {
        const element = products[i];
        const id = btoa(`gid://shopify/ProductVariant/${element.id}`);
        queryFilter.push(`${id}`);
      }

      if ( queryFilter.length === 0 ) {
        return 'Error';
      }



      
      var query = 
      `query($filter: [ID!]!) {
        nodes(ids: $filter) {
          ... on ProductVariant {
            id
            product {
              title
              onlineStoreUrl
            }
            priceV2 {
              amount
            }
            image {
              altText
              transformedSrc
            }
          }
        }
      }`
      ;
      
      fetch('https://hihealthaz.myshopify.com/api/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Shopify-Storefront-Access-Token': '68ea7446a0c03ed6c46da4f4c1f620c3'
        },
        body: JSON.stringify({
          query,
          variables: { filter: queryFilter },
        })
      })
      .then(r => r.json())
      .then(data => this.renderProducts(data));
    }
  }
})